/* eslint-disable */
import { GetterTree } from "vuex";
import { ProposalStatus } from "@/models/proposalStatus";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { ProposalStatusState } from "@/types/proposalStatus";

const getters: GetterTree<ProposalStatusState, RootState> = {
  list: (state) => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: (state) => {
    return state.pagination || new Pagination();
  },
  single: (state) => {
    return state.single || new ProposalStatus();
  },
  selectItem: (state) => {
    return state.pagination
      ? state.pagination.data.map((proposalStatus) =>
          ProposalStatus.toSelectItem(proposalStatus)
        )
      : [];
  },
  find: (state) => (id: number) => {
    return state.pagination
      ? state.pagination.data.find((proposalStatus) => {
          return proposalStatus.id == id;
        })
      : new ProposalStatus();
  },
};

export default getters;
